export default __webpack_public_path__ + "static/Mbird-c4780291cf4f08cae1737d715e4eb056.png";